module.exports = __webpack_public_path__ + "assets/images/rbyearend-01.jpg?v=6093289b";